import { Plan } from '@/types'

export interface PlanDetails {
    id: Plan
    name: string
    price: number
    limits: {
        spaces: number | 'unlimited'
        users: number | 'unlimited'
        bookingsPerMonth: number | 'unlimited'
        pix: boolean
        photosPerSpace: number
    }
    features: string[]
    recommended?: boolean
    checkoutUrl?: string
}

export const PLANS: Record<Plan, PlanDetails> = {
    lite: {
        id: 'lite',
        name: 'SpaceRub Lite',
        price: 0,
        limits: {
            spaces: 2,
            users: 25,
            bookingsPerMonth: 50,
            pix: false,
            photosPerSpace: 1
        },
        features: [
            '2 Espaços',
            '25 Usuários (Clientes)',
            '50 Reservas (Degustação)',
            'Painel Administrativo'
        ]
    },
    prime: {
        id: 'prime',
        name: 'SpaceRub Prime',
        price: 49.90,
        limits: {
            spaces: 5,
            users: 100,
            bookingsPerMonth: 1250,
            pix: true,
            photosPerSpace: 5
        },
        features: [
            '5 Espaços',
            '100 Usuários',
            '1.250 Reservas/mês',
            'Suporte por Email',
            'Pagamento via PIX/MP',
            'Fotos por Espaço: 5'
        ],
        checkoutUrl: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=421482568bd44f7dbcad36d1e3ea29f8'
    },
    advanced: {
        id: 'advanced',
        name: 'SpaceRub Advanced',
        price: 99.90,
        limits: {
            spaces: 10,
            users: 200,
            bookingsPerMonth: 3750,
            pix: true,
            photosPerSpace: 15
        },
        features: [
            '10 Espaços',
            '200 Usuários',
            '3.750 Reservas/mês',
            'Suporte Prioritário',
            'Fotos por Espaço: 15'
        ],
        recommended: true,
        checkoutUrl: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=f2e3aac783c14f1c8853620718fe0880'
    },
    ultra: {
        id: 'ultra',
        name: 'SpaceRub Ultra',
        price: 199.90,
        limits: {
            spaces: 'unlimited',
            users: 'unlimited',
            bookingsPerMonth: 'unlimited',
            pix: true,
            photosPerSpace: 30
        },
        features: [
            'Espaços Ilimitados',
            'Usuários Ilimitados',
            'Reservas Ilimitadas',
            'Gerente de Conta Dedicado',
            'Fotos por Espaço: 30'
        ],
        checkoutUrl: 'https://www.mercadopago.com.br/subscriptions/checkout?preapproval_plan_id=8abe5ee7e77f456883ff65e92db599af'
    }
}
